import {
  useWSModal,
  WSForm,
  WSInputText
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { queriesComplianceEntities } from "@query";
import { validatorStringTextNumbersSymbols } from "../../../../../shared/validators/validatorStringTextNumbersSymbols";
import { LayoutFormEdit } from "./LayoutFormEdit";

type FormData = { newValue: string };

type Props = {
  onClose: () => void;
};

export const FormEditDBA: React.FC<Props> = props => {
  const queryComplianceEntities =
    queriesComplianceEntities.listComplianceEntities.useQuery({});
  const primaryEntity = queryComplianceEntities.data?.data?.find(
    entity => !entity.subject
  );
  const [mutate, meta] =
    queriesComplianceEntities.updateComplianceEntity.useMutation({
      dependencies: [
        queriesComplianceEntities.listComplianceEntities.queryKeyBase
      ],
      onSuccess: props.onClose
    });

  return (
    <WSForm<FormData>
      defaultValues={{
        newValue: primaryEntity?.doingBusinessAs || ""
      }}
      onSubmit={data => {
        if (!primaryEntity?.id) {
          return;
        }

        mutate({
          complianceEntityId: primaryEntity.id,
          complianceEntityUpdate: { doingBusinessAs: data.newValue }
        });
      }}
      validationSchema={Yup.object({
        newValue: validatorStringTextNumbersSymbols
      })}
    >
      <LayoutFormEdit
        isLoading={meta.isLoading}
        error={meta.error}
        onCancel={props.onClose}
      >
        <WSForm.Field
          name="newValue"
          label="Doing business as (DBA) (optional)"
          component={WSInputText}
        />
      </LayoutFormEdit>
    </WSForm>
  );
};

export const useModalEditDBA = () =>
  useWSModal(FormEditDBA, {
    title: "Doing business as (DBA)",
    size: "S"
  });
